const screenTheme = document.documentElement.classList;
export const toLight = (Totheme, setTheme) => {
  if (Totheme === "lightTheme") {
    screenTheme.remove("dark");
    localStorage.setItem("theme", Totheme);
  } else {
    screenTheme.add("dark");
    localStorage.setItem("theme", Totheme);
  }
};
